exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e44cff10] .v-input__control{width:100%!important}", ""]);

// exports
